<template>
  <ChatMessageTemplateModeView
    v-if="mode === 'view'"
    v-model:selectedGuid="selectedGuid"
    :disableInsert="disableInsert"
    @close="emit('close')"
    @insert="handleInsert"
    @changeMode="handleChangeMode"
  />
  <ChatMessageTemplateModeCreate
    v-if="mode === 'create'"
    @update:selectedGuid="setSelectedGuid"
    @close="emit('close')"
    @changeMode="handleChangeMode"
  />
  <ChatMessageTemplateModeEdit
    v-if="mode === 'edit'"
    @close="emit('close')"
    :selectedGuid="selectedGuid"
    @changeMode="handleChangeMode"
  />
  <ChatMessageTemplateModeDelete
    v-if="mode === 'delete'"
    v-model:selectedGuid="selectedGuid"
    @close="emit('close')"
    @changeMode="handleChangeMode"
  />
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import ChatMessageTemplateModeView from './ChatMessageTemplateModeView.vue'
import ChatMessageTemplateModeCreate from './ChatMessageTemplateModeCreate.vue'
import ChatMessageTemplateModeEdit from './ChatMessageTemplateModeEdit.vue'
import ChatMessageTemplateModeDelete from './ChatMessageTemplateModeDelete.vue'

import type { ChatMessageTemplate } from '@/types/app'
import type { ChatMessageTemplateModalMode } from './types'

withDefaults(
  defineProps<{
    /*
     * 挿入ボタンを消すオプション
     * テンプレートの編集のみを行うときに有効にする
     */
    disableInsert?: boolean
  }>(),
  {
    disableInsert: false,
  }
)

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'insert', template: ChatMessageTemplate): void
}>()

const selectedGuid = ref<Maybe<ChatMessageTemplate['guid']>>()
const mode = ref<ChatMessageTemplateModalMode>('view')

const handleInsert = (value: ChatMessageTemplate) => {
  emit('insert', value)
}

const setSelectedGuid = (value: ChatMessageTemplate['guid']) => {
  selectedGuid.value = value
}

const handleChangeMode = (value: ChatMessageTemplateModalMode) => {
  mode.value = value
}
</script>
